module.exports = __webpack_public_path__ + "af5f52de6eea025d6126d211e0a50068.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/T@2x.png
// module id = 845
// module chunks = 0